// @ts-nocheck
import { useEffect, useRef } from 'react';
import NProgress from 'nprogress';
import { useLocation } from 'react-router-dom';
import { GlobalStyles } from '@mui/material';

const nprogressGlobalStyles = (theme) => ({
  '#nprogress': {
    pointerEvents: 'none',
    '& .bar': {
      top: 0,
      left: 0,
      height: 3,
      width: '100%',
      position: 'fixed',
      zIndex: theme.zIndex?.snackbar + 1,
      backgroundColor: theme.palette?.primary.main,
      boxShadow: `0 0 2px ${theme.palette?.primary.main}`,
    },
    '& .peg': {
      right: 0,
      opacity: 1,
      width: 100,
      height: '100%',
      display: 'block',
      position: 'absolute',
      transform: 'rotate(3deg) translate(0px, -4px)',
      boxShadow: `0 0 10px ${theme.palette?.primary.main}, 0 0 5px ${theme.palette?.primary.main}`,
    },
  },
});

let configured = false;

export default function NProgressBar() {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!configured) {
      NProgress.configure({ showSpinner: false, trickleSpeed: 200, minimum: 0.12 });
      configured = true;
    }
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return undefined;
    }
    NProgress.start();
    const t = setTimeout(() => NProgress.done(), 300);
    return () => clearTimeout(t);
  }, [pathname]);

  return <GlobalStyles styles={nprogressGlobalStyles} />;
}
